export default class Image {
  constructor(x, y) {
    this.x = x;
    this.y = y;
  }
  increaseX() {
    this.x = this.x + 1;
  }
  decreaseX() {
    this.x = this.x - 1;
  }
  increaseY() {
    this.y = this.y + 1;
  }
  decreaseY() {
    this.y = this.y - 1;
  }
}
